<template>
<div class="message-box dialog-mask" @click="$close">
    <div class="dialog-content">
      <div class="dialog-body">
        <div>
            <!--<img class="sold-out img-fluid" src="https://images.prismic.io/bonjourbrigadeiro/13abe1a2-f782-48f3-9d6a-b5684ea6032c_sold-out.png?auto=compress,format" />-->
            <img class="sold-out img-fluid" :src="content.img" />
        </div>
        <prismic-rich-text :field="content.text"/>
      </div>
      <footer>
        <button id="okButton" class="form-control" type="text" size="mini" @click="$close">OK</button>
      </footer>
    </div>
  </div>
</template>
<script>

export default {
    name: 'Dialog',
    props: ['content']
    }
</script>
<style lang="scss">
.sold-out {
    max-width: 500px;
    @media (max-width: 550px){
        max-width: 300px;
    }
}
#okButton {
    background-color: #300B02;
    color: #FFEDD6;
    border: 1px solid #FFEDD6;
    &:hover {
        background-color: #a94442;
        cursor: pointer;
    }
}
.dialog-mask
    {
        position:fixed;
        z-index: 300;
        top:0;
        right:0;
        bottom:0;
        left:0;
        display:-ms-flexbox;
        display:flex;
        -ms-flex-align:center;
        align-items:center;
        -ms-flex-pack:center;
        justify-content:center;
        background-color:rgba(0,0,0,.33)
    }
.dialog-content
    {
        margin:0 20px;
        padding:20px 30px;
        border:1px solid #ebeef5;
        border-radius:4px;
        background-color:#fff;
        box-shadow:0 2px 12px 0 rgba(0,0,0,.1);
        color:#303133}.dialog-content header{margin:10px 0 26px;
        font-size:18px;
        font-weight:700
    }
.dialog-content .el-button,.dialog-content p
    {
        font-size:inherit
    }
.dialog-content p
    {
        white-space:pre-wrap
    }
.dialog-content .el-button
    {
        -ms-flex:1;
        flex:1;
        border:0;
        color:#409eff;
        -webkit-appearance:none;
        -moz-appearance:none;
        appearance:none
    }
.dialog-content footer
    {
        display:-ms-flexbox;
        display:flex;
        margin-top:24px
    }
.message-box .dialog-content
    {
        min-width:240px;
        text-align:center;
        font-size:16px
    }
.example code
    {
        font-family:Inconsolata,monospace;
        font-size:14px
    }
.example p>code
    {
        display:inline-block;
        padding:1px 4px;
        border-radius:4px;
        background-color:#ecf8ff
    }
.example-card .el-card__body
    {
        padding:0
    }
.example-card pre
    {
        overflow:auto
    }
.example-card .demo
    {
        padding:20px;
        display:-ms-flexbox;
        display:flex
    }
.example-card .demo>*
    {
        margin:0 10px
    }
.example-card .demo>:first-child
    {
        margin-left:0
    }
.example-card .demo>:last-child
    {
        margin-right:0
    }
.example-card .el-collapse-item__header
    {
        padding:0 10px 0 20px
    }
.example-card .el-collapse-item__content
    {
        padding:0 20px;
        padding-bottom:20px
    }
.example-card .el-collapse-item:last-child .el-collapse-item__header
    {
        border-bottom:0
    }
</style>